import React from "react";
import { Button } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

export interface SettingsEditButtonProps {
  /** Enter edit mode. */
  onClick: () => void;
}

/**
 * The shared read-mode "Edit" affordance for a settings surface. Extracted so
 * the same button renders identically whether it sits in {@link SettingsTabShell}
 * (above the field rows) or is hoisted into a page header's `actions` slot
 * (e.g. GiftCardSettings). Keeping one source of the button means its styling
 * stays in lockstep across every placement.
 *
 * Styled as the brand-teal filled button used for header actions elsewhere
 * (e.g. PoliciesSettings) — `color="var(--brand-teal)"` with Mantine's default
 * filled variant.
 */
export default function SettingsEditButton({
  onClick,
}: SettingsEditButtonProps) {
  return (
    <Button
      color="var(--brand-teal)"
      leftSection={<IconEdit size={16} />}
      onClick={onClick}
    >
      Edit
    </Button>
  );
}
